<div class="wrapper">
    <div
        id="container-members-modal-close-button"
        class="close-modal-button"
        (click)="closeModal()"
        (mouseenter)="isCloseButtonHovered = true"
        (mouseleave)="isCloseButtonHovered = false"
    >
        <img
            [src]="
                'assets/svg/reusable-svg/close' +
                (isCloseButtonHovered ? '-hover' : '') +
                '.svg'
            "
            alt="close-icon"
        />
    </div>
    <div class="inner-wrapper">
        <div class="header-wrapper">
            <img src="assets/svg/reusable-svg/members.svg" alt="members-icon" />
            <span class="span-overflow-ellipsis-nowrap">
                {{ 'containerMembers.header' | translate }}
            </span>
        </div>
        <div class="container-name-wrapper">
            <span class="span-overflow-ellipsis-nowrap">{{
                container.name
            }}</span>
        </div>

        <div class="members-and-requests-management-wrapper">
            <div class="members-wrapper">
                <span class="title">{{
                    'containerMembers.membersContainerTitle' | translate
                }}</span>

                <div class="members-list-container">
                    <div *ngIf="members?.length" class="flex-starter">
                        <ul class="tryb-new-design-scroll-bar">
                            <li
                                class="list-element"
                                *ngFor="let member of members; let i = index"
                            >
                                <span>{{ member.memberName }}</span>
                                <div class="icons-container">
                                    <div
                                        [id]="
                                            'container-members-modal-delete-member-button-' +
                                            i
                                        "
                                        class="icon-wrapper red-hover"
                                        (mouseenter)="
                                            hoveredMemberListEltIdx = i
                                        "
                                        (mouseleave)="
                                            hoveredMemberListEltIdx = -1
                                        "
                                        (click)="deleteMember(i)"
                                    >
                                        <img
                                            [src]="
                                                'assets/svg/reusable-svg/icon-trash-can' +
                                                (hoveredMemberListEltIdx === i
                                                    ? '-hover'
                                                    : '') +
                                                '.svg'
                                            "
                                            alt="delete-icon"
                                        />
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div *ngIf="!members?.length" class="placeholder-wrapper">
                        <span>
                            {{
                                'containerMembersAdministration.members.' +
                                    getTranslationKeyForContainerType()
                                    | translate
                            }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="requests-wrapper">
                <span class="title">{{
                    'containerMembers.requestsContainerTitle' | translate
                }}</span>
                <div class="requests-list-container">
                    <div
                        *ngIf="joinRequests?.values?.length > 0"
                        class="flex-starter"
                    >
                        <ul
                            class="requests-list tryb-new-design-scroll-bar"
                            [class.has-requests]="
                                joinRequests?.values?.length > 0
                            "
                        >
                            <li
                                class="list-element request-row"
                                *ngFor="
                                    let request of joinRequests.values;
                                    let i = index
                                "
                            >
                                <input
                                    type="checkbox"
                                    [id]="
                                        'container-members-request-checkbox-' +
                                        i
                                    "
                                    [checked]="isRequestSelected(i)"
                                    (change)="toggleRequestSelection(i)"
                                    class="hidden-checkbox"
                                />
                                <label
                                    class="icons-container"
                                    [for]="
                                        'container-members-request-checkbox-' +
                                        i
                                    "
                                >
                                    <div class="icon-wrapper">
                                        <img
                                            class="checkmark"
                                            src="assets/svg/reusable-svg/icon-checkmark.svg"
                                            *ngIf="isRequestSelected(i)"
                                            alt="checkmark-icon"
                                        />
                                    </div>
                                </label>
                                <label
                                    [for]="
                                        'container-members-request-checkbox-' +
                                        i
                                    "
                                    class="request-label"
                                >
                                    <span>
                                        {{ request.userAccountDisplayName }}
                                    </span>
                                </label>
                            </li>
                        </ul>
                        <div class="grant-of-use-section">
                            <div class="grant-of-use-checkbox-row">
                                <input
                                    type="checkbox"
                                    id="container-members-grant-of-use-checkbox"
                                    [(ngModel)]="grantOfUseChecked"
                                    class="hidden-checkbox"
                                />
                                <label
                                    class="custom-checkbox"
                                    for="container-members-grant-of-use-checkbox"
                                >
                                    <img
                                        class="checkmark"
                                        src="assets/svg/reusable-svg/icon-checkmark.svg"
                                        *ngIf="grantOfUseChecked"
                                        alt="checkmark-icon"
                                    />
                                </label>
                                <label
                                    for="container-members-grant-of-use-checkbox"
                                    class="grant-of-use-label"
                                >
                                    {{
                                        'containerMembers.grantOfUseText'
                                            | translate
                                    }}
                                </label>
                            </div>
                            <div class="request-actions">
                                <button
                                    type="button"
                                    id="container-members-modal-accept-requests-button"
                                    class="action-button accept-button"
                                    [disabled]="
                                        !grantOfUseChecked ||
                                        selectedRequestIndices.size === 0
                                    "
                                    (click)="answerSelectedRequests(true)"
                                    [attr.title]="
                                        grantOfUseChecked
                                            ? undefined
                                            : ('containerMembers.acceptDisabledTooltip'
                                              | translate)
                                    "
                                >
                                    {{
                                        'containerMembers.acceptButton'
                                            | translate
                                    }}
                                </button>
                                <button
                                    type="button"
                                    id="container-members-modal-decline-requests-button"
                                    class="action-button decline-button"
                                    [disabled]="
                                        selectedRequestIndices.size === 0
                                    "
                                    (click)="answerSelectedRequests(false)"
                                >
                                    {{
                                        'containerMembers.declineButton'
                                            | translate
                                    }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div
                        *ngIf="!joinRequests?.values?.length"
                        class="placeholder-wrapper"
                    >
                        <span>
                            {{
                                'containerMembersAdministration.requests.empty'
                                    | translate
                            }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
